import { ApiBase } from "./ApiBase";
import { IApiArray, IApiGetQuery, SystemNotification } from "../index";

export interface ISystemNotification {
	/** ID for this version of the Notification */
	id: string;
	/**
	 * Unique ID across multiple versions of the notification
	 * If you want to update a existing notification you need to supply the same `msgKey`
	 */
	msgKey: string;
	/** some flags for this notification */
	flags: SystemNotificationFlags;
	/** project ID */
	dscid: number;
	/** Receiver of the notification */
	dscaid: number;
	/** creation time */
	created: number;
	/** Time of deletion or `null` is not deleted */
	deleted: number;

	/** Name of the source, i.e. "Certs & Docs" */
	sourceName: string;
	/** A icon displayed next to the {@link sourceName} */
	sourceIcon: string;

	/** Short title for the Notification */
	title: string;
	/** a more detailed than the title */
	content: string;

	/**
	 * HTML version of the message
	 * is used to send the notification as mail
	 */
	htmlContent: string;

	/**
	 * what should happen if you click the notification
	 */
	dsLoader: {
		url: string;
		target: string;
		element: string;
	};

	/** timestamp then this version of the notification was mark as read the first time */
	firstRead: number;
	/** method that will be used to deliver this notification */
	deliveryMethod: SystemNotificationDeliveryMethod;
	/** detailed information about how and then this notification was delivered and read */
	deliveries: ISystemNotificationDelivery[];
}

export enum SystemNotificationFlags {
	/** can't be marked as read by the user */
	NOT_READABLE = 1,
}

export enum SystemNotificationDeliveryMethod {
	/**
	 * deliver using push
	 */
	PUSH = 1,
	/**
	 * deliver using mail, will happen immediately & always (unlike {@link OPTIONAL_MAIL})
	 */
	MAIL = 2,
	/**
	 * deliver using email, but only if the notification wasn't read otherwise
	 * the mail will send depending a user options. for example once a day.
	 */
	OPTIONAL_MAIL = 4,

	/**
	 * shortcut, push to web app and send optional mail.
	 * Should be the default for most cases
	 */
	PUSH_OPTIONAL_MAIL = PUSH & OPTIONAL_MAIL,
}

export interface ISystemNotificationDelivery {
	id: string;
	method: SystemNotificationDeliveryMethod;
	send: number;
	read: number;
}

export class SystemNotificationApi extends ApiBase {
	public getMyUnread(): Promise<IApiArray<SystemNotification>> {
		return this.client.callCfc("SystemNotification.getMyUnread", {});
	}

	public get(query: IApiGetQuery): Promise<IApiArray<SystemNotification>> {
		return this.client.callCfc("SystemNotification.get", {});
	}

	public markAsRead(id: string): Promise<SystemNotification> {
		return this.client.callCfc("SystemNotification.markAsRead", {});
	}
}



// WEBPACK FOOTER //
// ./src/lib/api/SystemNotificationApi.ts